import {
  Grid
} from '@material-ui/core';

import React, { useCallback } from 'react';

import { translate } from 'utils/translation';

import PropTypes from 'prop-types';

import { TextField } from 'components/forms/inputs';

export const SequenceListFilters = ({
  currentFilters, setCurrentFilters
}) => {
  const name = (currentFilters.find((filt) => filt.key === 'name')
    && currentFilters.find((filt) => filt.key === 'name').label) || null;

  const description = (currentFilters.find((filt) => filt.key === 'description')
    && currentFilters.find((filt) => filt.key === 'description').label) || null;

  const handleChangeInput = useCallback((event) => {
    const { name: filterName, value } = event.target;
    if (value) {
      setCurrentFilters([...currentFilters.filter((filt) => filt.key !== filterName), { key: filterName, label: value }]);
    } else {
      setCurrentFilters([...currentFilters.filter((filt) => filt.key !== filterName)]);
    }
  }, [currentFilters, setCurrentFilters]);

  return (
    <Grid container direction="column">
      <TextField
        autoComplete="off"
        label={translate('common.name')}
        name="name"
        value={name}
        onChange={handleChangeInput}
      />

      <TextField
        autoComplete="off"
        label={translate('common.description')}
        name="description"
        value={description}
        onChange={handleChangeInput}
      />
    </Grid>

  );
};

SequenceListFilters.propTypes = {
  currentFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setCurrentFilters: PropTypes.func.isRequired
};